import React from "react";
import { NavLink } from "react-router-dom";

const teamMembers = [
  {
    image: require("./../../images/our-team4/pic1.png"),
    membername: "Jugal Kishore Kumawat",
    position: "CEO and Founder ",
  },
  {
    image: require("./../../images/our-team4/pic2.png"),
    membername: "Rohit Kumawat ",
    position: "CA and CFO",
  },
  {
    image: require("./../../images/our-team4/pic3.png"),
    membername: "Ashley Fletcher",
    position: "Finances",
  },
];

class Team3 extends React.Component {
  render() {
    return (
      <>
        <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
          <div className="container">
            {/* TITLE START */}
            <div className="section-head">
              <div className="mt-separator-outer separator-left">
                <div className="mt-separator">
                  <h2 className="text-uppercase sep-line-one ">
                    <span className="font-weight-300 text-primary">Our</span>{" "}
                    Leadership Team
                  </h2>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            {/* IMAGE Team START */}
            <div className="section-content">
              <div className="row">
                {teamMembers.map((item, index) => (
                  <div
                    key={index}
                    className="col-md-4 col-sm-6 col-xs-6 col-xs-100pc m-b30   "
                  >
                    <div className="our-team-1 hover-animation-1">
                      <div className="profile-image scale-in-center">
                        <img src={item.image} alt="" />
                      </div>
                      <div className="figcaption">
                        <h4>{item.membername}</h4>
                        <h5>{item.position}</h5>
                        <p>
                          Which is worse, that everyone has his price, or that
                          the price is always so low.
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Team3;
